import React from 'react';
import { GameQuestion } from '../types';

interface GameCardProps {
  question: GameQuestion;
  onAnswer: (answer: string) => void;
  selectedAnswer?: string;
  showResult?: boolean;
  cheatMode?: boolean;
}

export const GameCard: React.FC<GameCardProps> = ({
  question,
  onAnswer,
  selectedAnswer,
  showResult = false,
  cheatMode = false
}) => {
  return (
    <div className="game-card">
      <div className="question-header">
        <h2>{question.question}</h2>
      </div>
      
      <div className="options-grid">
        {question.options.map((option, index) => {
          let className = 'option-button';
          
          if (showResult) {
            if (cheatMode && option === question.correctAnswer) {
              className += ' correct';
            } else if (option === selectedAnswer && option !== question.correctAnswer) {
              className += ' incorrect';
            } else if (!cheatMode && option === selectedAnswer) {
              className += ' selected';
            }
          } else {
            if (option === selectedAnswer) {
              className += ' selected';
            } else if (cheatMode && option === question.correctAnswer) {
              className += ' cheat-hint';
            }
          }
          
          return (
            <button
              key={index}
              className={className}
              onClick={() => !showResult && onAnswer(option)}
              disabled={showResult}
            >
              {option}
            </button>
          );
        })}
      </div>
      
      {showResult && cheatMode && (
        <div className="result-info">
          <p className="muscle-details">
            <strong>{question.muscle.name_jp}</strong> ({question.muscle.name_en})
          </p>
          <div className="muscle-info">
            <p><strong>起始:</strong> {question.muscle.origin}</p>
            <p><strong>停止:</strong> {question.muscle.insertion}</p>
            <p><strong>神経支配:</strong> {question.muscle.innervation}</p>
            <p><strong>血液供給:</strong> {question.muscle.blood_supply}</p>
          </div>
        </div>
      )}
    </div>
  );
};